const texts = {
  authorizationTabs: { signIn: "Accedi", signUp: "Iscriviti" },
  general: {
    save: "Salva",
    close: "Chiudi",
    next: "Successivo",
    clearStep: "Annulla il passaggio",
    tryAgain: "Prova di nuovo",
    errorTitle: "Errore",
    service: "Servizio:",
    message: "Messaggio:",
    statusCode: "Codice stato:",
  },
  months: {
    "1": "Gennaio",
    "2": "Febbraio",
    "3": "Marzo",
    "4": "Aprile",
    "5": "Maggio",
    "6": "Giugno",
    "7": "Luglio",
    "8": "Agosto",
    "9": "Settembre",
    "10": "Ottobre",
    "11": "Novembre",
    "12": "Dicembre",
  },
  signIn: {
    title: "Benvenuto su MultiMatch",
    description: "Crea il tuo CRF (Controlled Release Fertilizer - Fertilizzante a Rilascio Controllato) personalizzato",
    email: "E-Mail",
    password: "Password",
    forgotPassword: "Hai dimenticato la password?",
    keepMeLoggedIn: "Resta collegato da questo computer",
    keepMeLoggedInMobile: "Resta collegato da questo dispositivo",
    emailApproved: "Il tuo indirizzo e-mail è stata autorizzato\naccedi per proseguire",
  },
  updatePassword: {
    title: "Imposta una nuova password",
    description: "La password dovrebbe avere",
    password: "Nuova password",
    confirmPassword: "Conferma la password",
    submitMessage: "Aggiorna la password",
    success: "La password è cambiata: ti stiamo reindirizzando alla pagina del login.",
    UPDATE_PASSWORD_CONFIRMED: "La password è stata confermata",
    errors: {
      EMAIL_TOKEN_INVALID: "Il token per reinizializzare la password non è valido",
      EMAIL_NOT_CONFIRMED: "L`indirizzo e-mail non è stato confermato.",
      MAIL_NOT_CONFIRMED: "L`indirizzo e-mail non è stato confermato.",
      PASSWORD_UPDATE_SUCCESS: "La password è stata aggiornata",
      PASSWORD_UPDATE_FAILED: "Non è stato possibile aggiornare la password",
      TEMP: "Token non valido oppure e-mail non confermata",
    },
    sendEmail: "Abbiamo inviato un`e-mail\nVerifica la posta in entrata",
    errorPasswordRequired: "Il campo Password e Conferma password non possono essere vuoti",
  },
  signUp: {
    note: "Iscriviti per salvare le informazioni e poterle utilizzare in futuro",
    passwordNote: "La password deve contenere almeno 8 caratteri tra cui una lettera maiuscola: una minuscola e un numero.",
    fullName: "Nome",
    country: "Paese",
    region: "Regione",
    email: "E-Mail",
    mainInterest: "Interesse principale",
    expertise: "Competenza",
    password: "Password",
    confirmPassword: "Conferma la password",
    iAccept: "Accetto",
    termsAndConditions: "Termini e condizioni di Haifa",
    and: "e",
    privacyPolicy: "Policy sulla privacy",
    next: "Successivo",
    emailSent: "Abbiamo inviato un`e-mail\nVerifica la posta in entrata",
    didntGet: "Non l`hai ricevuta?",
    checkBoxError: "Approva: per favore",
  },
  validationErrors: {
    fieldIsRequired: "Compilare i campi obbligatori",
    incorrectEmailFormat: "L`indirizzo e-mail non esiste",
    passwordValidation: "Password non valida",
    minimumValue: "Value must be larger than {0}",
    passwordsDontMatch: "Le passwords non corrispondono",
    lettersOnly: "Usare unicamente delle lettere",
    incorrectEmail: "Indirizzo e-mail errato",
    IncorrenctPassword: "Password errata",
    emailExisted: "Questo indirizzo e-mail è già presente nel sistema",
    termsCheckbox: "Necessario",
    valueOutOfRange: "Il valore deve essere compreso tra {0} e {1}",
    invalidDateFormat: "Inserisci una data valida",
    dateMustBeGreater: "La data del raccolto deve essere successiva a quella della messa a dimora",
    dateMustBeAtLeastTwoMonths: "La data deve riferirsi ad almeno due mesi",
    noServiceForSpecificCountry: "Non offriamo servizi nel paese selezionato",
    dateMaxDatesTwelveMonth: "Massimo un anno.",
  },
  errorMessages: {
    generic: "Si è verificato un errore: riprova più tardi",
    LOGIN_FAILED: "Il nome utente o la password non corrisponde",
    MISSING_EMAIL: "E` richiesto un indirizzo e-mail.",
    EMAIL_INVALID: "Indirizzo e-mail errato",
    DUPLICATEUSERNAME: "Questo indirizzo e-mail è già presente nel sistema",
    PASSWORD_INVALID: "Password non valida",
    USERNAME_INVALID: "Il nome non può contenere caratteri speciali o numeri",
    SPECIALIZATION_INVALID: "Specializzazione non valida",
    MAIN_INTEREST_INVALID: "Interesse principale non valido",
    REGION_INVALID: "Regione non valida",
    REGION_NOT_EXIST: "La regione non esiste",
    USER_NOT_FOUND: "L`utente non esiste",
    USER_ALREADY_EXIST: "L`utente è già presente",
    MISSING_VALUES_TO_CONFIRM_REGISTRATION: "La registrazione non è andata a buon fine - valori mancanti",
    EMAIL_SENT_TO_USER: "L`e-mail è stata inviata all`utente",
    REGISTRATION_FAILED: "Registrazione non andata a buon fine",
    TOKEN_INVALID: "Token autenticazione non valido",
    EMAIL_CONFIRMED_ALREADY: "L`indirizzo e-mail è già stato confermato",
    NO_SOLUTION_MATCH: "Non è stata trovata alcuna soluzione immediatamente disponibile",
    EMAIL_CONFIRMED_SUCCESS: "L`e-mail è stata confermata",
    VALIDATION_FAILED: "La convalida non è andata a buon fine",
    ACCEPT_TERMS_INVALID: "Valore accettazione termini non valido",
    SAVING_ITEM_FAILED: "Non è stato possibile salvare l`elemento",
    SAVED_ITEM_NOT_FOUND: "L`elemento non esiste",
    UPDATING_RECIPE_ITEM_FAILED: "Non è stato possibile aggiornare l`elemento",
    REMOVING_RECIPE_ITEMS_FAILED: "Non è stato possibile eliminare la ricetta",
    REMOVING_GRAPH_ITEMS_FAILED: "Non è stato possibile eliminare il grafico",
    ITEM_UPDATED_SUCCESSFULLY: "L`elemento è stato correttamente aggiornato",
    ITEM_DELETED_SUCCESSFULLY: "L`elemento è stato correttamente eliminato",
    RAW_MATERIAL_PARAMETERS_NOT_VALID: "Non è stato possibile salvare la nuova materia prima  - parametri non validi",
    SAVING_RAW_MATERIAL_FAILED: "Non è stato possibile salvare la nuova materia prima",
    RAW_MATERIAL_ALREADY_EXIST: "La materia prima esiste già",
    REMOVING_ITEM_FAILED: "Non è stato possibile eliminare l`elemento",
    UPDATING_ITEMS_FAILED: "Errore durante l`aggiornamento dell`elemento nel DB",
    CALCULATOR_IS_NOT_READY: "Stiamo caricando i dati del calcolatore",
    NUTRIENT_TYPE_INVALID: "Tipo di nutriente non valido",
    BLEND_INVALID: "Miscela Multicote non valida",
    TYPE_INVALID: "tipo non valido per una delle proprietà",
    MISSING_SAVED_ITEM_ID: "Id elemento mancante nella richiesta",
    ITEM_NOT_FOUND: "Elemento non trovato",
    RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "La ricetta non può contenere più di 6 materie prime",
    RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
      "La ricetta deve contenere almeno una materia prima rivestita e fino a 5 materie non rivestite",
    ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "Uno o più id materia prima non valido nella ricetta",
    PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "La percentuale della miscela deve corrispondere al 100%",
    START_DATE_REQUIRED: "Inserire una data di inizio",
    END_DATE_REQUIRED: "Inserire una data di fine",
    END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "La data di fine deve essere successiva alla data di inizio",
    YIELD_VALUE_REQUIRED: "Inserire la resa",
    COUNTRY_INVALID: "Paese non valido",
    CROP_CODE_INVALID: "Coltura non valida",
    MESUREMENTS_INVALID: "Unità di misura non valida",
    SOIL_AND_WATER_COMBINATION_INVALID: "Combinazione terreno e acqua non valida",
    MONTHS_AND_TEMPATURES_INVALID: "Valori inseriti per mesi e temperature non validi",
    shareWithNoSaving: "Spiacenti: non è possibile condividere elementi non salvati",
    ITEM_NAME_TOO_SHORT: "il nome è troppo corto",
    ITEM_RENAME_FAILED: "ITEM_RENAME_FAILED",
    ITEM_DUPLICATE_FAILED: "ITEM_DUPLICATE_FAILED",
    UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED",
  },
  rightDrawer: {
    showMoreText: "Mostra",
    contactUs: "Contact us",
    findDealer: "Find a dealer",
  },
  fmSummary: {
    shortSummaryTitle1: "Colture",
    shortSummaryTitle2: "Terreno",
    shortSummaryTitle3: "Soluzione",
    shortSummaryTitle4: "Azienda agricola",
    shortSummaryTitleGraphPage: "Personalizza",
    ourProducts: "I nostri prodotti",
    summary: "Dati raccolti",
    seeMoreProducts: "Vedi più prodotti Multicote™",
    recipeCoatedElements: "Elementi rivestiti",
    recipeUncoatedElements: "Elementi non rivestiti",
  },
  fmLeftMenu: {
    title: "MultiMatch",
    subTitle: "Programmi di nutrizione delle piante\npersonalizzati",
    menuLabels: {
      label0: "Shlomit Adary",
      label1: "Soluzione Multicote Agri",
      label2: "Soluzione Multicote",
      label3: "Elementi salvati",
      label4: "Informazioni",
      label5: "Contattaci",
    },
    logout: "Esci",
  },
  steps: {
    cropsDesktop: "Colture",
    cropsMobile: "Caratteristiche della tua coltura",
    soilDesktop: "Terreno",
    soilMobile: "Temperatura e caratteristiche del terreno",
    resultsDesktop: "Risultati",
    resultsMobile: "Risultati",
    farmDesktop: "Azienda agricola\n(Facoltativo)",
    farmMobile: "Pratica aziendale (Facoltativo)",
    customizeDesktop: "Personalizza\n(Facoltativo)",
    customizeMobile: "Crea la tua miscela (Facoltativo)",
  },
  agriSolution: {
    npkAlert: "NPK is Different from Crop Demand:",
    title: "Soluzione Multicote Agri",
    selectCropLabel: "Seleziona la tua coltura",
    expectedYieldLabel: "Resa prevista",
    plotSizeLabel: "Altezza dimensione lotto",
    plantingDateLabel: "Data di messa a dimora",
    finalHarvestExpectedDate: "Data prevista per il raccolto finale",
    selectPlotLocationLabel: "Seleziona localizzazione lotto",
    selectPlotLocationNote: "Sii il più preciso possibile. Ciò aiuta a valutare i dati relativi al clima",
    selectArea: "oppure seleziona un`area",
    selectOrAddNew: "Seleziona dalla lista o aggiungine  una nuova",
    onTheMap: "sulla mappa",
    select: "Seleziona",
    selectSoilLabel: "Temperatura e caratteristiche del terreno",
    waterRegime: {
      title: "Seleziona il regime idrico",
      description: "Che fenomeni di precipitazioni sono presenti?",
      sliderMarks: {
        "1": "Arido",
        "2": "Semi-arido",
        "3": "Semi-tropicale",
        "4": "Tropicale",
      },
    },
    soilType: {
      title: "Seleziona la tessitura del terreno",
      description: "Qual è la tessitura del lotto di terreno?",
      sliderMarks: {
        "1": "Sabbioso, argilloso e sabbioso",
        "2": "Mediamente sabbioso",
        "3": "Limo, terriccio limoso, argilla limosa",
        "4": "Argilloso limoso, argilloso",
      },
    },
    soilWarning:
      "Le esigenze in termini di nutrienti si basano sulla resa prevista. Un programma di fertilizzazione Multicote è pensato per sostituire tutti i macronutrienti che la coltura rimuoverà. Il terreno viene considerato come un buffer e il contenuto del terreno in termini di nutriente non viene preso in considerazione. Ciononostante: è buona pratica prelevare dei campioni di terreno ogni 2 o 3 anni e applicare le migliorie necessarie sulla base dell'analisi del terreno. Ciò garantisce il mantenimento della fertilità del suolo e la migliora nel tempo.",
  },
  fmDescriptionSnippet: {
    title: "Benvenuto nel calcolatore della soluzione Multicote",
    description:
      "Un software nel cloud destinato ad agricoltori in proprio o in società: che permette di creare in pochi passi la propria soluzione personalizzata per i fertilizzanti a cessione controllata (CRF)",
  },
  fmDropdownWithImg: { title: "Seleziona la tua coltura" },
  back: "Indietro",
  fmRecommendedProduct: {
    volume: "Volume raccomandato",
    method: "Metodo di applicazione",
    link: "Fai clic per ottenere una curva di rilascio",
  },
  pageStep1: {
    soilTemp: "Seleziona la temperatura del terreno",
    change: "Modifica",
    note: "Seleziona la tua coltura dalla lista e inserisci le date previste per la messa a dimora e il raccolto oltre che la resa attesa",
    cfpTitle: "Carbon & Environmental footprint",
    cfpDesc: "assessment tool is now included in MultiMatch to help you improve your environmental impact",
    cfpButton: "Read More",
  },
  fertilizationPopup: {
    title: "Applicazione del nutriente fertilizzante",
    subTitle: "Conosci il totale di nutrienti che attualmente apporti con il programma di fertilizzazione che utilizzi al momento?",
    thirdTitle: "Seleziona `Li conoso` e calcola la nuova formula personalizzata",
    iKnow: "Li conosco",
    iDontKnow: "Non li conosco",
    next: "Successivo",
  },
  saveProcessPopup: {
    title: "Salva questa procedura",
    subTitle: "Abbiamo notato che sono presenti processi non salvati: intendi continuare?",
    dontShowThisMessage: "Non mostrarmelo di nuovo",
    noThanks: "No: grazie",
    save: "Salva",
  },
  clearStepPopup: {
    title: "Annulla il passaggio",
    subTitle: "Confermi di voler cancellare i dati di questa fase?",
    dontShowThisMessage: "Non mostrarmelo di nuovo",
    noGoBack: "Indietro",
    clear: "Cancella i dati",
  },
  deleteItemPopup: {
    title: "Elimina elemento",
    subTitle: "Confermi di voler rimuovere questo elemento?",
    no: "No",
    yes: "Sì",
  },
  saveItemPopup: {
    title: "Salva la soluzione",
    label1: "Nome della soluzione",
    label2: "Area",
    getBack: "Vorrei che un agronomo di Haifa verifichi la selezione che ho effettuato e che mi dica cosa ne pensa.",
    save: "Salva",
    snackbar: "Elemento salvato",
  },
  pageStep4: {
    title: "Pratica aziendale",
    table: {
      nutrients: "Nutrienti",
      nutrientsUnit: "(Kg/Ha)",
      label1: "Pratica agricoltore",
      label2: "Fabbisogni della coltura",
      label3: "Nutrienti salvati dalle perdite nell`ambiente",
    },
    question: "Qual è la tua pratica aziendale?",
    questionDescription:
      "Se usi già dei fertilizzanti che danno rese normali: ti preghiamo di dirci qual è l`NPK totale applicato per stagione. Utilizzeremo queste percentuali per calcolare le percentuali ottimali di Multicote per la tua formula personalizzata.",
    fill: "Compila indicando qual è la tua pratica aziendale",
    buttomDescription:
      "Utilizzando Multicote l`efficienza dei nutrienti rivestiti aumenta considerevolmente: consentendo di ridurre la quantità totale di nutrienti applicata e di conseguenza l`inquinamento dell`acqua di falda: così come la creazione di concentrazione salina indesiderata nel terreno .",
    warningText1: "Suggeriamo di contattare un",
    warningText2: "agronomo professionista di Haifa o un suo distributore",
    warningText3: "per confermare la selezione effettuata prima di applicarla.",
    clearThisStep: "Annulla il passaggio",
    cfpBanner: "Data of used application rates helps the system calculate carbon and environmental footprint ",
    next: "Successivo",
    save: "Salva",
  },
  multicoteTable: { mesurmentUnit: " (%)" },
  mainInterests: { OFA: "Agricoltura in campo aperto", N: "Vivaio" },
  metricMethods: { "1": "Metrico", "2": "Imperiale" },
  specialties: {
    "1": "Giardinaggio \\ hobby",
    "2": "Coltivatore",
    "3": "Impresa agricola",
    "4": "Formazione agricola\\ servizi",
    "5": "Commercio",
    "6": "Altro",
  },
  PageReleaseChart: {
    greenMessage: {
      title1: "ISTRUZIONI D`USO",
      description1: "Applicare sempre i prodotti Multicote nella zona radicale.",
      description2: "Coprire con terreno o pacciamatura per ottenere prestazioni ottimali.",
      subTitle: "Best practice:",
      description3:
        "Applicare in fila durante la semina oppure distribuire uniformemente prima della coltivazione e incorporare la miscela Multicote nel semenzaio.",
      title2: "QUANDO",
      description4: "Durante la semina o durante la preparazione del lotto: ma non più di 2 settimane prima della semina.",
      title3: "QUANTO",
      description5:
        "La tecnologia Multicote può essere usata in sicurezza: ma per ottenere i migliori risultati: verificare che i macchinari siano calibrati correttamente.",
      title4: "CURVA DI RILASCIO",
      description6: "La curva di rilascio mostra il rilascio dei nutrienti in base alla temperatura prevista del terreno",
      radioButtonLabel: "Scegli un tema",
      shareUnsavedItem: "Spiacenti: non è possibile condividere elementi non salvati",
    },
    currentDayRemainingReleaseValues: {
      preValue: "Mese",
      postValue: "NPK rimanenti:",
      currentPrecentage: "Remaining NPK (Percentage):",
      Percentage: "(Percentage)",
    },
    sendToAgronomist: {
      preUserName: "L`utente",
      preCrop: "sta pianificando una soluzione per la coltura",
      preYield: "con una resa stimata di",
      preStartingDate: "Data di inizio:",
      preFinalDate: "Data di fine:",
      preSolutionName: "Soluzione:",
      materialCode: "Material code:",
      preVolumeApplication: "Quantità da applicare",
    },
    warning: {
      description: "Sarà necessario aggiungere anche meso e microelementi. Per ottenere delle raccomandazioni più complete, ",
      boldDescription: "contatta l`agronomo o il distributore Haifa locale",
    },
    buttons: {
      downloadFile: "Scarica PDF",
      sendToPro: "Invia all`agronomo",
      shareLink: {
        desktop: "Condividi link",
        mobile: "Condividi",
      },
    },
  },
  wideTable: {
    kodkod: {
      title1: "Rilascio del fertilizzante",
      title2: "per mese (Kg/Ha)",
    },
    sideLabel: { label1: "N (var)", label2: "P", label2_1: "O", label3: "K" },
    months: {
      month1: "Gen",
      month2: "Feb",
      month3: "Mar",
      month4: "Apr",
      month5: "Mag",
      month6: "Giu",
      month7: "Lug",
      month8: "Ago",
      month9: "Set",
      month10: "Ott",
      month11: "Nov",
      month12: "Dic",
    },
    caroselHeader: { title: "Rilascio mensile (%)" },
    next: "Successivo",
    back: "Indietro",
  },
  saveItemsPage: {
    title: "Soluzioni salvate",
    inputPlaceholder: "Inserisci un tipo di coltura o un`area per trovare le miscele che hai salvato",
    mobile_inputPlaceholder: "Inserisci un tipo di coltura o un`area",
    clearAll: "Cancella tutto",
    loadMore: "Carica altro",
    savedItemCard: {
      rename: "Rinomina",
      delete: "Cancella",
      duplicate: "Duplica",
      contact: "Contattaci",
      showTo: "Mostra l`elemento a un agronomo di Haifa",
    },
  },
  multicoteSolutionPage: {
    stepOne: {
      firstInput: "Seleziona miscela",
      secondInput: "Data di inizio:",
      radioLabel1: "P2O5 K2O",
      radioLabel2: "PK",
      selectTemperature: "Seleziona temperatura",
      calculateButton: "Calcola",
      setTempratureButton: "Temperature impostate",
    },
    title: "Soluzione Multicote",
    changeCalculationSetting: "Modifica le impostazioni di calcolo",
    save: "Salva",
    line: "Linea",
    bar: "Istogramma",
    graphCodCodTitle: "Rilascio del fertilizzante",
  },
  pageStep3: {
    carbonFootprintLoadingText: "Non chiudere questa finestra",
    carbonFootprintDesc: "Valutazione impatto ambientale e impronta carbonica dell’intero ciclo di raccolto",
    carbonFootprintButtonText: "Calcolate per me!",
    subTitle: "Raccomandazioni",
    customize: {
      bestSuit: "Formula più adatta",
      subDescription: "Abbiamo trovato questa formula che si adatta meglio alle esigenze della tua coltura",
      title: "Vuoi modificare la formula?",
      secondSubDescription:
        "Puoi modificare questa formula oppure crearne una su misura affinché si adatti meglio alle condizioni locali specifiche. Bastano pochi passaggi",
      button: "Modifica la formula",
      topLink: "Curva di rilascio",
    },
    bottomTitle: "Formula già disponibile",
    bottomDescriptionWithMatch: "Questa è la formula già disponibile più vicina alle tue esigenze",
    bottomDescriptionWithoutMatch: "Non siamo riusciti a trovare una formula che possa soddisfare le tue esigenze in termini di terreno e clima",
    recommendedProduct: {
      description:
        "Le nostre raccomandazioni si basano sulle esigenze della coltura solo relativamente all`NPK: secondo il\n fabbisogno noto di tali nutrienti. L`applicazione di meso e microelementi sarà effettuata in funzione dell`analisi del terreno e delle esigenze della coltura.",
    },
    save: "Salva",
    inSoil: "In terreno",
    metric: "Kg/Ha",
    imperial: "ST/Acre",
  },
  pageStep5: {
    title: "Crea la tua miscela",
    updateButton: "Aggiorna il calcolo di N, P, K",
    recipeValidationError: "La ricetta deve contenere almeno un materiale rivestito e un massimo di 6 elementi in totale",
    save: "Salva",
    bestSolution: "Soluzione migliore",
    subTitle1: "Seleziona fino a 6 materie prime in totale",
    coated: "Rivestite",
    uncoated: "Non rivestite",
    completePercentage: "Percentuale completata della tua miscela Multicote:",
    missing: "mancante",
    clear: "Annulla il passaggio",
    continueButton: "Continua alla tabella di rilascio",
    bottomDrawer: {
      savedItem: "Elemento salvato",
      rename: "Rinomina",
      delete: "Cancella",
      reset: "Reimposta",
      update: "Aggiorna",
    },
    uncoatedHelperText: "",
    updateCard: {
      leftSpan: "N, P, K vengono calcolati in base alla selezione di materie prime:",
      errorMessage: {
        missingWord: "Increase",
        extraWord: "Decrease",
        rightPart: "% for calculation",
      },
    },
  },
  userAreaPage: {
    title: "Il mio profilo",
    tab1: "Profilo utente",
    tab2: "La mia raccolta di materie prime",
    inputLabel1: "Nome",
    inputLabel2: "Paese",
    inputLabel3: "E-Mail",
    inputLabel4: "Il tuo interesse principale",
    inputLabel5: "Competenza (Facoltativo)",
    button: "Aggiorna",
    inputSecondPage: "Non rivestite",
    messages: { success: "Profilo correttamente aggiornato" },
    uncoatedInputHelperText: "",
  },
  contactUs: {
    title: "Hai domande? Hai bisogno di consulenza?",
    secondTitle: "Grazie per aver visitato la nostra piattaforma",
    description:
      "Siamo lieti di rispondere a qualsiasi domanda e ci piacerebbe conoscere la tua esperienza per poter continuare a migliorare la nostra offerta.",
    inputLabel1: "Paese",
    inputLabel2: "Regione",
    inputLabel3: "Posizione",
    inputLabel4: "Sistema di coltivazione",
    inputLabel5: "Numero di telefono cellulare",
    inputLabel6: "Dimensione area (ha)",
    inputLabel7: "Indirizzo e-mail",
    inputLabel8: "Il tuo messaggio",
    back: "Indietro",
    send: "Invia",
    messages: {
      success: "Grazie per la tua e-mail. Ti risponderemo al più presto.",
      invalidPhoneNumber: "Numero di telefono cellulare non valido",
    },
  },
  PDFfile: {
    mateData: {
      createdBy: "Creato da:",
      name: "Nome:",
      location: "Luogo:",
      phoneNumber: "Numero di telefono:",
      Date: "Data:",
      Time: "Orario:",
    },
    summaryData: {
      nutrientsApplied: "Nutrienti applicati:",
      collectedDataTitle: "Dati raccolti:",
      cropsTitle: "Colture",
      cropProp: "Coltura",
      yieldProp: "Resa",
      plotSize: "Plot Size",
      plantingDateProp: "Data di messa a dimora",
      harvestDateProp: "Data del raccolto",
      soilTitle: "Terreno",
      WaterRegimeProp: "Regime idrico",
      soilProp: "Suolo",
      customizedTitle: "Personalizzato",
      recipeCoatedTitle: "Elementi rivestiti",
      recipeUncoatedTitle: "Elementi non rivestiti",
      recommended: "Raccomandato",
      MaterialCodeProp: "Codice materiale",
    },
    waver: {
      title: "ESONERO DI RESPONSABILITA",
      body: {
        before: "Prima dell`utilizzo l`agricoltore deve valutare l`adeguatezza del prodotto rispetto all`utilizzo previsto.",
        theGrower: "L`agricoltore si assume tutti rischi e la responsabilit per eventuali danni conseguenti e incidentali. Questo prodotto",
        isSold: "viene venduto senza garanzia di alcun tipo, espressa o implicita, relativamente alla sua commerciabilit",
        orFitness: " o idoneit per scopi specifici.",
        caution: "Attenzione: ",
        harmful: "Nocivo in caso di ingestione. Tenere lontano dalla portata dei bambini.\nConservare in un luogo fresco e asciutto",
      },
    },
    descriptionRecommended:
      "Le nostre raccomandazioni si basano sulle esigenze della coltura solo relativamente all`NPK: secondo il\nfabbisogno noto di tali nutrienti. L`applicazione di meso e microelementi sarà effettuata in funzione dell`analisi\ndel terreno e delle esigenze della coltura.",
    howToUse: {
      title: "ISTRUZIONI D`USO",
      body: {
        firstLine: "Applicare sempre i prodotti Multicote nella zona radicale.",
        secondLine: "Per ottenere prestazioni migliori necessario ricoprire con alcuni centimetri di terra",
        thirdLine: "o pacciame",
        fourthLinePartOne: "Best practice:",
        fourthLinePartTwo: "Applicare in fila durante la semina.",
        fifthLinePartOne: "Oppure:",
        fifthLinePartTwo: "Distribuire uniformemente prima della coltivazione e incorporare la miscela Multicote™",
        fifthLinePartThree: " nel letto di semina.",
        forOptimalPerformance:
          "Per ottenere migliori prestazioni, prima di procedere alla messa a dimora, miscelare i prodotti Multicoteג„¢ con il terriccio.",
        mixMulticote: " Prima di procedere alla messa a dimora, mescolare i prodotti Multicoteג„¢ con il terriccio.",
        secondBestPractice: "Seconda best practice - Dibbing:",
        forLate: "per un`applicazione successiva, fare dei buchi intorno alla pianta ed applicare il Multicote™",
        evenly: "coprire uniformemente con del terreno.",
      },
    },
    when: {
      title: "QUANDO",
      body: {
        firstLine: "Durante la semina o durante la preparazione del lotto, ma non pidi 2 settimane prima della semina ",
        secondLine: "Messa a dimora. ",
      },
    },
    howMuch: {
      title: "QUANTO",
      body: {
        firstLine: "La tecnologia Multicote™ sicura da utilizzare, ma per ottenere i migliori risultati, assicurarsi che",
        secondLine: "i macchinari siano calibrati correttamente.",
      },
    },
    releaseCurve: {
      title: "CURVA DI RILASCIO",
      body: "La curva di rilascio mostra il rilascio dei nutrienti in base alla temperatura attesa del terreno",
    },
    nameOfFile: "Multicote™ - La nostra soluzione.pdf",
  },
  ShareEmail: {
    title: "Istruzioni",
    body: {
      please: "Puoi",
      find: "trovare",
      attached: "in allegato",
      recommendation: "le raccomandazioni",
      Thank: "Grazie",
      you: "!",
      Haifa: "Haifa",
      Group: "Group",
    },
  },
  autoCompleteInput: {
    firstSpan: "I valori non sono validi",
    secondSpan: "max N, P, K is 46: 54: 62",
    thirdSpan: "La somma max è 66",
    noOptions: "Nessuna opzione",
  },
  sideMenu: {
    termsAndCondition: {
      title: "Termini e condizioni",
      contentTitle: "Termini di utilizzo",
    },
    privacyPolicy: { title: "Policy sulla privacy" },
    copyRightTitle: "Copyright 2021 Haifa",
    poweredBy: "Powered by",
  },
  cfpTable: {
    savingTitle: "Risparmio di CO2 Eq.",
    reducedCo2: "Per",
    reducedCo2PerPlot: "Per lotto",
    rating: {
      excellent: "Eccellente",
      worse: "Peggiore",
    },
    tableColumns: {
      envParams: "Parametri ambientali",
      multiTech: "Tecnologia Multicote™",
      tradTech: "Applicazione tradizionale",
      performanceRating: "Prestazioni di valutazione della tecnologia Multicote™",
      index: "Indice",
    },
    tableRows: {
      carbonFootprint: {
        label: "Impronta di carbonio",
        measureUnit: "kg CO2 eq./Kg prodotto",
      },
      nLeaching: {
        label: "Lisciviazione N",
        measureUnit: "kg NO3/Kg prodotto",
      },
      nRunOff: {
        label: "Deflusso N",
        measureUnit: "kg NO3/Kg prodotto",
      },
      nVolatilization: {
        label: "Volatilizzazione N",
        measureUnit: "kg NH3/Kg prodotto",
      },
      terrestrialEutrophication: {
        label: "Eutrofizzazione terrestre",
        measureUnit: "kg P eq./Kg prodotto",
      },
    },
    carbonBannerTitle: "Calcolo del risparmio di carbonio",
    carbonBannerText: "((Impronta di carbonio dell’applicazione tradizionale)/ha - (Impronta di carbonio della tecnologia Multicote™)/ha) X Resa attesa T/Ha)",
  },
};
export default texts;
